/**
 * @function getFileByPath
 * @param  {string} path the file path
 * @return {boolean} `true` if found and `false` otherwise
 */
export default function getFileByPath(path) {
  const found = tree.findFirst(({ data }) => {
    const { path: currentPath } = data;
    if (currentPath) {
      return currentPath === path.replace(/\/$/, "") || currentPath === path;
    }
  });
  return Boolean(found);
}
